import React, { useEffect, useRef } from "react";
import { useCalendar } from "../../pages/Calendar/state/CalendarContext";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { getCalendarEvents } from "../../calendar/helpers/selectors/CalendarEvents";
import dayjs from "dayjs";

import "./CalendarView.css"; // <-- create this CSS file for custom styles

export default function CalendarView({ onSelectDate, filtersOpen }) {
    const { state, dispatch } = useCalendar();
    const calendarRef = useRef(null);

    useEffect(() => {
        const t = setTimeout(() => {
            calendarRef.current?.getApi().updateSize();
        }, 300);
        return () => clearTimeout(t);
    }, [filtersOpen]);

    if (!state) return <p>Loading calendar…</p>;

    const allEvents = getCalendarEvents({ state, calendarRef });
    const selectedDate = state.selectedDate;

    return (
        <div style={{ flex: 1 }}>
            <FullCalendar
                ref={calendarRef}
                plugins={[
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                    listPlugin,
                ]}
                initialView="dayGridMonth"
                headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
                }}
                events={allEvents}
                height="auto"
                eventDisplay="block"
                eventTimeFormat={{
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                }}
                eventDidMount={(info) =>
                    info.el.setAttribute("title", info.event.title)
                }
                eventClick={(info) =>
                    dispatch({
                        type: "SET_SELECTED_ITEM",
                        payload: info.event.extendedProps,
                    })
                }
                dateClick={(info) => {
                    const selected = dayjs(info.dateStr).format("YYYY-MM-DD");
                    dispatch({
                        type: "SET_SELECTED_DATE",
                        payload: selected,
                    });
                    onSelectDate?.(info.dateStr);
                }}
                dayCellClassNames={(arg) => {
                    const isSelected =
                        dayjs(arg.date).format("YYYY-MM-DD") === selectedDate;
                    return isSelected ? ["fc-day-selected"] : [];
                }}
            />
        </div>
    );
}